import { render, staticRenderFns } from "./artikli.editor.vue?vue&type=template&id=51051393&scoped=true&"
import script from "./artikli.editor.vue?vue&type=script&lang=ts&"
export * from "./artikli.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51051393",
  null
  
)

export default component.exports